import {
  MayTermSecondaryInfo,
  ConfirmationModal,
  AddEditMayTermModal,
  ErrorModal,
} from "components/reusables";
import { CuratedOrganization } from "models";
import React, { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import Img from "react-cool-img";
import { useHistory } from "react-router-dom";
import genericAvatar from "assets/images/generic_avatar.jpg";
import { deleteMayStory } from "services/mayTermService";

interface MayTermCardProps {
  mayTerm: CuratedOrganization;
}

export function MayTermCard({ mayTerm }: MayTermCardProps): JSX.Element {
  const [isShowingConfirmDelete, setIsShowingConfirmDelete] = useState(false);
  const [isShowingNewMayTermModal, setIsShowingNewMayTermModal] = useState(false);
  const [isDisplaying] = useState(mayTerm.display);
  const [error] = useState<Error | undefined>(undefined);
  const history = useHistory();
  return (
    <>
      <Row>
        <Col xs="auto" className="d-flex align-items-center p-0" />
        <Col>
          <Card style={{ opacity: isDisplaying ? 1 : 0.5 }}>
            <Card.Body>
              <Row>
                <Col xs={3} md={2} className="d-flex align-items-center">
                  <div className="img-square-container">
                    <Img
                      src={mayTerm.photoUrl || ""}
                      placeholder={genericAvatar}
                      alt={`${mayTerm.organization}`}
                      width="100%"
                      loading="lazy"
                    />
                  </div>
                </Col>
                <Col className="d-flex align-items-center">
                  <div>
                    <h2>{`Travel Opportunity in ${mayTerm.location}`} </h2>
                    <MayTermSecondaryInfo mayTerm={mayTerm} />
                  </div>
                </Col>
                <Col xs="auto" className="d-flex align-items-center">
                  <div className="d-flex flex-column justify-content-center">
                    <Button
                      onClick={() => history.push(`map-view-admin/may-term-details/${mayTerm.id}`)}
                      className="p-3"
                      variant="link"
                      size="lg"
                    >
                      Learn More
                      <i className="ml-2 fas fa-arrow-right" />
                    </Button>

                    <div className="buttons spaced-children">
                      <div className="buttons spaced-children">
                        <Button
                          variant="outline-success"
                          size="lg"
                          onClick={() => setIsShowingNewMayTermModal(true)}
                        >
                          Edit
                        </Button>
                      </div>
                      <Button
                        variant="outline-danger"
                        size="lg"
                        onClick={() => setIsShowingConfirmDelete(true)}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <ConfirmationModal
        title="Delete Member Profile?"
        message="Are you sure you want to delete this department member profile? This action cannot be undone."
        confirmText="Delete"
        variant="danger"
        show={isShowingConfirmDelete}
        onConfirm={() => {
          return deleteMayStory(mayTerm.id).finally(() => {
            window.location.reload();
          });
        }}
        onHide={() => setIsShowingConfirmDelete(false)}
      />
      <AddEditMayTermModal
        show={isShowingNewMayTermModal}
        setShow={setIsShowingNewMayTermModal}
        currentMayTerm={mayTerm}
      />
      <ErrorModal error={error} />
    </>
  );
}
